import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import OneSignal from 'react-onesignal'
import { initSentry, captureError } from './lib/sentry'
import './index.css'

initSentry()

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null } }
  static getDerivedStateFromError(e) { return { error: e } }
  componentDidCatch(error, info) { captureError(error, { componentStack: info?.componentStack }) }
  render() {
    if (this.state.error) return (
      <div style={{ padding:'2rem', fontFamily:'monospace', background:'#fff8f8', minHeight:'100vh' }}>
        <h2 style={{ color:'#c00', fontFamily:'sans-serif' }}>App crashed — copy this error and send it:</h2>
        <pre style={{ background:'#1a1a1a', color:'#ff6b6b', padding:'1.5rem', borderRadius:'8px', overflow:'auto', fontSize:'0.85rem', lineHeight:1.6 }}>
          {this.state.error.toString()}
          {'\n\n'}
          {this.state.error.stack}
        </pre>
      </div>
    )
    return this.props.children
  }
}

// Initialise OneSignal (only if App ID is set)
const osAppId = import.meta.env.VITE_ONESIGNAL_APP_ID
if (osAppId) {
  OneSignal.init({
    appId: osAppId,
    safari_web_id: 'web.onesignal.auto.4e6ae055-7872-4c1f-b42a-6c60bed16bbe',
    allowLocalhostAsSecureOrigin: true,
    notifyButton: { enable: false },
    promptOptions: {
      slidedown: {
        prompts: [{
          type: 'push',
          autoPrompt: false,
          text: {
            actionMessage: 'Stay updated on your wedding planning — get reminders and alerts.',
            acceptButton: 'Allow',
            cancelButton: 'Not now',
          }
        }]
      }
    }
  })
}


// ── Service Worker (PWA) ────────────────────────────────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then(reg => {
        console.log('[Okoiya SW] Registered:', reg.scope)
        // Check for updates every time the app loads
        reg.update()
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing
          sw?.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available — prompt user or reload silently
              sw.postMessage({ type: 'SKIP_WAITING' })
            }
          })
        })
      })
      .catch(err => console.warn('[Okoiya SW] Registration failed:', err))
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
